export default __webpack_public_path__ + "static/noelle-7c1fa5e1def79954bd3c1e06876ea4c4.jpg";